import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import {
  getBillingDashboardClientList,
  getBillingDashboardTeamList,
} from "../../../../services/BillingDashboardAPI";
import FloatingLabelMonthPicker from "../../../../common/MonthPicker";
import { Button } from "react-bootstrap";
import InvoiceLineItemPipeline from "../CommonDashboard/BillingSpecialistDashboard/InvoiceLineItemPipeline";
import InvoiceReportsSummaryData from "../CommonDashboard/BillingSpecialistDashboard/InvoiceReportsSummaryData";
import InvoiceTrendNDistribution from "../CommonDashboard/BillingSpecialistDashboard/InvoiceTrendNDistribution";
import InvoiceLeaderBoardData from "../CommonDashboard/BillingSpecialistDashboard/InvoiceLeaderBoardData";
import InvoiceActionData from "../CommonDashboard/BillingSpecialistDashboard/InvoiceActionData";

interface BillingSpecialistSummaryTypeProps {
  onTabChange: () => void;
  userRole: string;
}

const currencyData = [
  {
    label: "USD",
    value: "USD",
  },
  {
    label: "INR",
    value: "INR",
  },
];

const BillingSpecialistSummaryType: React.FC<
  BillingSpecialistSummaryTypeProps
> = ({ onTabChange, userRole }) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [showRushNotesSummary, setShowRushNotesSummary] = useState(false);

  const [teamOption, setTeamOption] = useState<any[]>([]);
  const [team, setTeam] = useState<string | number | null>(null);
  const [clientOption, setClientOption] = useState<any[]>([]);
  const [client, setClient] = useState<string | number | null>(null);
  const [month, setMonth] = useState<Date | null>(new Date());
  const [currencyOptions, setCurrencyOptions] = useState<any[]>(currencyData);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");

  const [filters, setFilters] = useState({
    teamId: team,
    clientId: client,
    currencyType: selectedCurrency,
    yearMonth: month,
  });

  const fetchClientTeamData = async () => {
    try {
      const teamData = await getBillingDashboardTeamList();
      setTeamOption(teamData || []);

      const clientData = await getBillingDashboardClientList();
      setClientOption(clientData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchClientTeamData();
  }, [userRole]);

  const handleCurrencyChange = (e: any) => {
    const selectedValue = e.target.value;

    const selectedOption = currencyOptions.find(
      (opt) => String(opt.value) === String(selectedValue),
    );

    setSelectedCurrency(selectedValue);
  };

  const handleSearch = () => {
    setFilters({
      teamId: team,
      clientId: client,
      currencyType: selectedCurrency,
      yearMonth: month,
    });
  };

  return (
    <>
      <Container fluid className="px-4 ">
        <Row>
          <Col sm={3} className="selection_dropdown">
            <SearchableSingleSelectDropdown
              label="Team"
              value={team}
              options={teamOption}
              onChange={(e) => {
                setTeam(e.target.value);
              }}
              name="team"
            />
          </Col>
          <Col sm={3} className="selection_dropdown">
            <SearchableSingleSelectDropdown
              label="Client"
              value={client}
              options={clientOption}
              onChange={(e) => {
                setClient(e.target.value);
              }}
              name="client"
            />
          </Col>
          <Col sm={2}>
            <FloatingLabelMonthPicker
              label="Billing Month"
              value={month}
              onChange={(value) => {
                setMonth(value);
              }}
            />
          </Col>
          <Col sm={2} className="selection_dropdown">
            <SearchableSingleSelectDropdown
              label="Currency"
              value={selectedCurrency}
              options={currencyOptions}
              onChange={handleCurrencyChange}
              name="currencyID"
            />
          </Col>
          <Col sm={2} className="selection_dropdown">
            <Button
              className="btn btn-primary d-flex px-2 p-2 align-items-center justify-content-center"
              onClick={handleSearch}
            >
              <span className="material-symbols-outlined me-1">search</span>
              Search
            </Button>
          </Col>
        </Row>
      </Container>
      <Container fluid className="px-4 dashboard">
        <Row className="mt-4 mb-4 case-summary align-items-stretch">
          <Col md={6}>
            <InvoiceActionData
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              filters={filters}
            />
          </Col>
          <Col md={6}>
            <InvoiceReportsSummaryData
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              filters={filters}
            />
          </Col>
        </Row>
        <Row className="mt-4 mb-4 case-summary">
          <Col md={12}>
            <InvoiceLineItemPipeline
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              filters={filters}
            />
          </Col>
        </Row>
        <Row className="mt-4 mb-4 case-summary">
          <Col md={12}>
            <InvoiceTrendNDistribution
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              filters={filters}
            />
          </Col>
        </Row>
        <Row className="mt-4 mb-4 case-summary align-items-stretch">
          <Col md={12}>
            <InvoiceLeaderBoardData
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              filters={filters}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BillingSpecialistSummaryType;
